import { TypedDocumentString } from '@haaretz/s-fragments/structures';
import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { fetch } from '@haaretz/s-graphql-fetcher';
export const PurchasePagePersonalQueryDocument = new TypedDocumentString(`
    query PurchasePagePersonalQuery($couponId: String, $pathSegment: String, $selectedOfferId: String, $ticketId: String, $userId: String, $cartData: Boolean, $previousSteps: String, $flow: String, $countryCode: String, $currency: String) {
  PurchasePage(
    couponId: $couponId
    pathSegment: $pathSegment
    selectedOfferId: $selectedOfferId
    ticketId: $ticketId
    userId: $userId
    cartData: $cartData
    previousSteps: $previousSteps
    flow: $flow
    countryCode: $countryCode
    currency: $currency
  ) {
    pageData {
      ...PageDataFragment
    }
  }
}
    fragment PageDataFragment on PageData {
  allSteps {
    ...StepDataFragment
  }
  contentId
  couponId
  couponErrorMessage
  toggleKicker {
    ...PurchaseToggleKickerFragment
  }
  right {
    ...PurchaseOfferFragment
  }
  marketingBullets {
    ...MarketingBulletFragment
  }
  left {
    ...PurchaseOfferFragment
  }
  personalCouponId
  steps {
    ...StepDataFragment
  }
  specialSaleData {
    ...SpecialSaleDataFragment
  }
  thankYouPageText
  cartData {
    ...CartDataFragment
  }
  image {
    ...ImageFragment
  }
  selectedOffer {
    ...SelectedOfferFragment
  }
  abTest {
    ...AbTestDataFragment
  }
  log
  userProducts
  userType
  designVersion
  counter {
    ...CounterFragment
  }
  pageType
}
fragment StepDataFragment on StepData {
  __typename
  content {
    ...HtmlNodeFragment
  }
  instructions
  messageIds
  messages
  name
  title
  mobileInstructions
  mobileTitle
}
fragment HtmlNodeFragment on HtmlNode {
  __typename
  as: tag
  content
}
fragment PurchaseToggleKickerFragment on PurchaseToggleKicker {
  __typename
  billing
  text
}
fragment PurchaseOfferFragment on PurchaseOffer {
  __typename
  benefits {
    ...HtmlNodeFragment
  }
  benefitsHeading
  contentId
  description
  exclusive
  exclusiveStrip
  legalText {
    ...HtmlNodeFragment
  }
  line1Text {
    ...HtmlNodeFragment
  }
  line2Text {
    ...HtmlNodeFragment
  }
  note
  offerHighlight
  offerType
  paymentType
  periodCalc
  prices
  product
  productName
  productNumber
  promotionNumber
  saleCode
  thankYouMailTemplate
  currency
}
fragment MarketingBulletFragment on MarketingBullet {
  __typename
  text
  title
}
fragment SpecialSaleDataFragment on SpecialSaleData {
  __typename
  exclusive
  image {
    ...ImageFragment
  }
  title
}
fragment ImageFragment on htz_image_Image {
  __typename
  alt
  caption
  contentId
  credit
  files {
    __typename
    crops {
      __typename
      headline {
        ...ImageCropFragment
      }
      landscape {
        ...ImageCropFragment
      }
      regular {
        ...ImageCropFragment
      }
      square {
        ...ImageCropFragment
      }
      vertical {
        ...ImageCropFragment
      }
      wide {
        ...ImageCropFragment
      }
    }
    height
    path
    width
  }
  link
  photographer
  type
}
fragment ImageCropFragment on ImageCrop {
  __typename
  height
  width
  x
  y
}
fragment CartDataFragment on CartData {
  approveDebtClaim
  contentId
  currency
  periodCalc
  prices
  productNumber
  promotionNumber
  saleCode
  thankYouMailTemplate
  paymentType
  __typename
}
fragment SelectedOfferFragment on PurchaseOffer {
  __typename
  contentId
  periodCalc
  prices
  productNumber
  paymentType
  promotionNumber
  saleCode
  thankYouMailTemplate
  offerType
  currency
}
fragment AbTestDataFragment on AbTestData {
  testGroup
  testGroupLabel
  testName
  __typename
}
fragment CounterFragment on PurchaseCounter {
  endDate
  message {
    ...HtmlNodeFragment
  }
  buttonText
  buttonLink
  messageHeadline
}`);
export const usePurchasePagePersonalQuery = (variables, options)=>{
    return useQuery({
        queryKey: variables === undefined ? [
            'PurchasePagePersonalQuery'
        ] : [
            'PurchasePagePersonalQuery',
            variables
        ],
        queryFn: fetch(PurchasePagePersonalQueryDocument, variables),
        ...options
    });
};
usePurchasePagePersonalQuery.document = PurchasePagePersonalQueryDocument;
usePurchasePagePersonalQuery.getKey = (variables)=>variables === undefined ? [
        'PurchasePagePersonalQuery'
    ] : [
        'PurchasePagePersonalQuery',
        variables
    ];
export const useSuspensePurchasePagePersonalQuery = (variables, options)=>{
    return useSuspenseQuery({
        queryKey: variables === undefined ? [
            'PurchasePagePersonalQuery'
        ] : [
            'PurchasePagePersonalQuery',
            variables
        ],
        queryFn: fetch(PurchasePagePersonalQueryDocument, variables),
        ...options
    });
};
useSuspensePurchasePagePersonalQuery.document = PurchasePagePersonalQueryDocument;
useSuspensePurchasePagePersonalQuery.getKey = (variables)=>variables === undefined ? [
        'PurchasePagePersonalQuery'
    ] : [
        'PurchasePagePersonalQuery',
        variables
    ];
export const useInfinitePurchasePagePersonalQuery = (variables, options)=>{
    return useInfiniteQuery((()=>{
        const { queryKey: optionsQueryKey, ...restOptions } = options;
        return {
            queryKey: optionsQueryKey ?? variables === undefined ? [
                'PurchasePagePersonalQuery.infinite'
            ] : [
                'PurchasePagePersonalQuery.infinite',
                variables
            ],
            queryFn: (metaData)=>fetch(PurchasePagePersonalQueryDocument, {
                    ...variables,
                    ...metaData.pageParam ?? {}
                })(),
            ...restOptions
        };
    })());
};
useInfinitePurchasePagePersonalQuery.getKey = (variables)=>variables === undefined ? [
        'PurchasePagePersonalQuery.infinite'
    ] : [
        'PurchasePagePersonalQuery.infinite',
        variables
    ];
export const useSuspenseInfinitePurchasePagePersonalQuery = (variables, options)=>{
    return useSuspenseInfiniteQuery((()=>{
        const { queryKey: optionsQueryKey, ...restOptions } = options;
        return {
            queryKey: optionsQueryKey ?? variables === undefined ? [
                'PurchasePagePersonalQuery.infinite'
            ] : [
                'PurchasePagePersonalQuery.infinite',
                variables
            ],
            queryFn: (metaData)=>fetch(PurchasePagePersonalQueryDocument, {
                    ...variables,
                    ...metaData.pageParam ?? {}
                })(),
            ...restOptions
        };
    })());
};
useSuspenseInfinitePurchasePagePersonalQuery.getKey = (variables)=>variables === undefined ? [
        'PurchasePagePersonalQuery.infinite'
    ] : [
        'PurchasePagePersonalQuery.infinite',
        variables
    ];
usePurchasePagePersonalQuery.fetcher = (variables, options)=>fetch(PurchasePagePersonalQueryDocument, variables, options);

//# sourceMappingURL=PurchasePage.js.map